import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || 'Login failed');
        return;
      }

      // ✅ Store token and user info
      localStorage.setItem('jwtToken', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));

      // ✅ Redirect based on role
      if (data.user.role === 'SuperAdmin' || data.user.role === 'Admin') {
        navigate('/admin/dashboard/home');
      } else if (data.user.role === 'Employee') {
        navigate('/employee/dashboard');
      } else {
        setError('Unauthorized role');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('Something went wrong');
    }
  };

  return (
    <div className="login-page bg-gradient-to-br from-[#e0f2fe] via-[#f8fafc] to-[#f0fdf4]">
      <div className="flex justify-center items-center w-full h-full p-4">
        <div className="w-full max-w-md">
          <form onSubmit={handleLogin} className="bg-white p-8 rounded-2xl shadow-2xl border border-gray-100 transform transition-all duration-300 hover:shadow-3xl">
            
            {/* Logo/Header Section */}
            <div className="text-center mb-8">
              <h2 className="text-2xl font-extrabold text-[#173861] mb-3 tracking-tight">
                ITS: Infinity Tracking System
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed">
                Достъп до тракинг системата имат само служителите на Infinity Energy Solar.
              </p>
            </div>

            {/* Error Message */}
            {error && (
              <div className="mb-6 p-3 bg-red-50 border border-red-200 rounded-lg">
                <p className="text-red-600 text-sm font-medium text-center">{error}</p>
              </div>
            )}

            {/* Form Fields */}
            <div className="space-y-4">
              <div>
                <input
                  type="email"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg text-base focus:ring-2 focus:ring-[#173861] focus:border-[#173861] focus:outline-none transition-colors duration-200"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div>
                <input
                  type="password"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg text-base focus:ring-2 focus:ring-[#173861] focus:border-[#173861] focus:outline-none transition-colors duration-200"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
            </div>

            {/* Submit Button */}
            <button 
              type="submit" 
              className="w-full mt-6 bg-[#173861] text-white py-3 px-4 rounded-lg font-semibold text-base shadow-lg hover:bg-[#1e4a6b] focus:ring-2 focus:ring-[#173861] focus:ring-offset-2 transition-all duration-200 transform hover:scale-[1.02] active:scale-[0.98]"
            >
              Login
            </button>

            {/* Footer Note */}
            <div className="mt-6 text-center">
              <p className="text-xs text-gray-500">
                Secure access for Infinity Energy Solar employees only
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;